<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>

import { mapState } from "vuex";
export default {
  name: 'wl-tab',
  props: {},
  components: {

  },
  data() {
    return {
      showTab: false,
      tab:1,    
    };
  },
  watch:{
    $route(to, from) {
      this.initTab();
    }
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title'])
  },
  mounted() {
    this.initTab();
  },
  methods: {
    initTab(){
      this.showTab = this.$route.meta.isTab;
      var path = this.$route.path;
      if(['/master'].indexOf(path)!==-1){
        this.tab = 1;
      }else if(['/release'].indexOf(path)!==-1){
        this.tab = 2;
      }else if(['/interview'].indexOf(path)!==-1){
        this.tab = 3;
      }else if(['/mine'].indexOf(path)!==-1){
        this.tab = 4;
      }else{
        this.tab = 0;
      }
    },
    changeTab(tab){
      if(tab===this.tab){
        return false;
      }
      if(tab===1){
        this.$glf.goUrl('replace','/master',{})
      }
      if(tab===2){
        if(this.authToken){
          this.$glf.goUrl('replace','/release',{})
        }else{
          this.$toast('请登录后再进行此操作');
          this.$router.push({path:'/login'})
        }
      }
      if(tab===3){
        this.$glf.goUrl('replace','/interview',{})
      }
      if(tab===4){
        this.$glf.goUrl('replace','/mine',{})
      }
    }
  }

};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/wl-tab/index.vue